<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="article.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', article.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label>Status</label>
            <v-select
                v-model="article.status"
                :options="['published', 'draft']"
                :clearable="false"
            />
        </div>
        <div class="form-group col-12">
            <label>Premium article</label>
            <b-form-checkbox v-model="article.isPremium" switch />
        </div>
        <div class="form-group col-12">
            <label>Include in feed</label>
            <b-form-checkbox v-model="article.isFeatured" switch />
        </div>
        <div v-if="!editMode || (editMode && article.id)" class="col-12">
            <small v-if="hasError('content')" style="color: #dc3545">
                {{ getError('content') }}
            </small>

            <content-builder
                v-model="article.content"
                label="Content"
                :sections="{
                    hidden: true,
                    header: false,
                    double: true
                }"
            />
        </div>
    </div>
</template>

<script>
import ContentBuilder from '@/components/elements/ContentBuilder';

export default {
    components: {
        ContentBuilder
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            article: {}
        };
    },

    watch: {
        article: {
            handler() {
                this.$emit('input', this.article);
            },
            deep: true
        }
    },

    created() {
        this.article = { ...this.value };

        if (!this.article.content) {
            this.article.content = [];
        }
    },

    methods: {
        onContentChange(content) {
            this.article.content = content;
        },

        hasError(key) {
            return (
                this.validation.article[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.article,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
